import { IItemForGetShortInfo, ITotalPrice, IItemForGetShortDishInfo } from 'types';
import { IIDsShowInComboDishes } from '../../../../../../../editDishState/editDishContext';
import React from 'react';
import DishModificationCategorySelect from './components/DishModificationCategorySelect';
import DishModificationSubCategorySelect from './components/DishModificationSubCategorySelect';
import ModificationDishMultipleSelect from './components/ModificationDishMultipleSelect/ModificationDishMultipleSelect';
import DnDList from './components/DnDList';
import style from './DishModificationsField.module.scss';

interface IDishModificationsField {
	setDishModifications: (value: string[]) => void;
	setDishModificationCategory: (value: Nullable<string>) => void;
	totalPrices: ITotalPrice[];
	setDishModificationSubCategory: (value: Nullable<string>) => void;
	setFetchedDishModificationSubCategories: (value: IItemForGetShortInfo[]) => void;
	selectedDishModificationCategory: Nullable<string>;
	setFetchedDishModifications: (Value: IItemForGetShortInfo[]) => void;
	selectedDishModificationSubCategory: Nullable<string>;
	selectedDishModifications: string[];
	removeDishModification: (value: string) => void;
	fetchedDishModifications: IItemForGetShortDishInfo[];
	setIDsShowInComboDishes: (value: IIDsShowInComboDishes) => void;
	IDsShowInComboDishes: IIDsShowInComboDishes;
}

const DishModificationsField: React.FC<IDishModificationsField> = ({
	setDishModifications,
	totalPrices,
	setDishModificationCategory,
	selectedDishModificationCategory,
	setDishModificationSubCategory,
	setFetchedDishModificationSubCategories,
	selectedDishModifications,
	selectedDishModificationSubCategory,
	setFetchedDishModifications,
	fetchedDishModifications,
	removeDishModification,
	setIDsShowInComboDishes,
	IDsShowInComboDishes,
}) => {
	return (
		<div className={style.container} data-test="DishModificationsField">
			<div className={style.newDishModificationFields}>
				<DishModificationCategorySelect
					totalPrices={totalPrices}
					setDishModificationCategory={setDishModificationCategory}
				/>
				<DishModificationSubCategorySelect
					selectedDishModificationCategory={selectedDishModificationCategory}
					setDishModificationSubCategory={setDishModificationSubCategory}
					setFetchedDishModificationSubCategories={setFetchedDishModificationSubCategories}
				/>
				<ModificationDishMultipleSelect
					selectedDishModifications={selectedDishModifications}
					selectedDishModificationSubCategory={selectedDishModificationSubCategory}
					setDishModifications={setDishModifications}
					setFetchedDishModifications={setFetchedDishModifications}
					setIDsShowInComboDishes={setIDsShowInComboDishes}
					IDsShowInComboDishes={IDsShowInComboDishes}
				/>
			</div>
			<DnDList
				fetchedDishModifications={fetchedDishModifications}
				selectedDishModifications={selectedDishModifications}
				setDishModifications={setDishModifications}
				removeDishModification={removeDishModification}
				IDsShowInComboDishes={IDsShowInComboDishes}
			/>
		</div>
	);
};

export default React.memo(DishModificationsField);
